export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-advertisement-line',
      title: 'We Run Targeted Ads',
      description:
        'We create and manage Meta ads that reach homeowners actively looking for house extensions and loft conversions in your area.',
    },
    {
      number: '02',
      icon: 'ri-phone-line',
      title: 'Enquiries Come In',
      description:
        'Interested homeowners call or submit enquiries. Every lead is captured and tracked so nothing slips through the cracks.',
    },
    {
      number: '03',
      icon: 'ri-customer-service-2-line',
      title: 'We Handle Initial Contact',
      description:
        'Our system ensures every enquiry is responded to quickly — whether by phone, text, or email — so you never miss an opportunity.',
    },
    {
      number: '04',
      icon: 'ri-calendar-check-line',
      title: 'You Get Qualified Leads',
      description:
        'We pass on homeowners who are genuinely interested and ready to discuss their project. You focus on what you do best: building.',
    },
  ];

  return (
    <section id="how-it-works" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-[#1a2947] mb-6">
            How It <span className="text-[#2B5797]">Works</span>
          </h2>
          <p className="text-xl text-[#334155] max-w-3xl mx-auto leading-relaxed">
            We handle the entire lead generation and follow-up process so you can focus on delivering great projects.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-[#F8FAFC] rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 relative"
            >
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-[#2B5797] text-white rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
                {step.number}
              </div>
              <div className="w-16 h-16 flex items-center justify-center bg-[#4A6FA5] rounded-full mx-auto mb-6 mt-4 shadow-md">
                <i className={`${step.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#334155] mb-4">{step.title}</h3>
              <p className="text-lg text-[#334155]/70 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
